<section>
  <form [formGroup]="formTaxType" class="container-style">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <app-custom-audit-info [userNameCreate]="taxTypeContract.userNameCreate"
          [createDate]="taxTypeContract.createDate" [userNameUpdate]="taxTypeContract.userNameUpdate"
          [updateDate]="taxTypeContract.updateDate"
          [reserveSpace]="true"></app-custom-audit-info>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 mb-1">
        <app-custom-select formControlName="countryId" [labelText]="'País'" [list]="listCountries" [required]="true"
          [recovery]="true" (onChangeSelect)="getCountry($event)">
        </app-custom-select>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12 col-12">
        <app-custom-input-text formControlName="code" [labelText]="'Código'" [required]="true" [recovery]="true"
          (onChangeText)="changeTaxType()">
        </app-custom-input-text>
      </div>
      <div class="col-lg-8 col-md-8 col-sm-12 col-12">
        <app-custom-input-text formControlName="name" [required]="true" [labelText]="'Nombre'">
        </app-custom-input-text>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 mb-1">
        <app-custom-select formControlName="jurisdictionId" [labelText]="'Jurisdicción'" [list]="listJurisdictions"
          [required]="true">
        </app-custom-select>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex justify-content-end align-items-end mt-sm-2 mt-md-3">
        <app-custom-button [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
          (onClick)="send()"></app-custom-button>
      </div>
    </div>
  </form>
</section>